import { makeAutoObservable } from "mobx";
import * as KeyNames from 'src/utils/KeyNames'

export default class CustomerStore {

  cartItemList: any[] = [];

  constructor() {

    makeAutoObservable(this);

    const tempItems = window.localStorage.getItem( KeyNames.CART_ITEM_LIST );
    if (tempItems && tempItems !== undefined) {

      this.cartItemList = JSON.parse(tempItems);
    }
  }

  setCartItemList(values:any[]) {

    this.cartItemList = values;
    window.localStorage.setItem(KeyNames.CART_ITEM_LIST, JSON.stringify(values));
  }

  addCartItemToList(newItem: any) {

    // console.log("🚀 ~ CustomerStore ~ addCartItemToList ~ newItem.prodId:", JSON.stringify(newItem));

    let eachBoxValue = null;
    if (newItem.uom === "Each/Box") {
      eachBoxValue = "Each";
    }

    // Find item by Product Id...
    if (this.cartItemList && this.cartItemList.length > 0) {

      const found = this.cartItemList.find(e => e.prodId === newItem.prodId);
      if (found) {  

        if (found.uom === "Each/Box" && found.eachBox === "Box") {  // Convert "Box" to "Each" Quantity and Change 'eachBox' value..

          // console.log("🚀 ~ CustomerStore ~ addCartItemToList ~ found:", JSON.stringify(found));
          found.quantity = (found.quantity * found.packSize);
          found.eachBox = "Each";
        }

        // When exists, add Quantity..
        found.quantity += 1;
      }
      else {  
        // Append item to List...
        this.cartItemList.push({...newItem, quantity: 1, eachBox: eachBoxValue});
      }
    }
    else {

      // Append item to List...
      this.cartItemList.push({...newItem, quantity: 1, eachBox: eachBoxValue});
    }

    window.localStorage.setItem(KeyNames.CART_ITEM_LIST, JSON.stringify(this.cartItemList));
  }

  addCartItemWithQty(newItem: any, quantity: number, paraEachBox: string) {

    // console.log("🚀 ~ CustomerStore ~ addCartItemWithQty ~ newItem.prodId:", JSON.stringify(newItem));
    // console.log("🚀 ~ CustomerStore ~ cartItemList ~ cartItemList:", JSON.stringify(this.cartItemList));

    let eachBoxValue = paraEachBox;
    if (newItem.uom !== "Each/Box") {
      eachBoxValue = null;
    }

    // Find item by Product Id...
    if (this.cartItemList && this.cartItemList.length > 0) {

      const found = this.cartItemList.find(e => e.prodId === newItem.prodId);
      if (found) {  

        // console.log("🚀 ~ CustomerStore ~ addCartItemWithQty ~ found:", JSON.stringify(found));

        if (found.uom === "Each/Box") {

          if (found.eachBox === "Each" && eachBoxValue === "Box") { // Previous "Each", Now "Box" added...

            found.quantity += (quantity * found.packSize);
          }
          else if (found.eachBox === "Box" && eachBoxValue === "Each") { // Previous "Box", Now "Each" added...

            found.quantity = (found.quantity * found.packSize) + quantity;
            found.eachBox = "Each";
          }
          else {
            // When exists, add Quantity..
            found.quantity += quantity;
          }
        }
        else {

          // When exists, add Quantity..
          found.quantity += quantity;
        }
      }
      else {  
        // Append item to List...
        this.cartItemList.push({...newItem, quantity: quantity, eachBox: eachBoxValue});
      }
    }
    else {

      // Append item to List...
      this.cartItemList.push({...newItem, quantity: quantity, eachBox: eachBoxValue});
    }

    window.localStorage.setItem(KeyNames.CART_ITEM_LIST, JSON.stringify(this.cartItemList));
  }

  removeCartItemFromList(productId: number) {

    const tempItems = this.cartItemList.filter(e => e.prodId !== productId);
    this.setCartItemList( tempItems );

    window.localStorage.setItem(KeyNames.CART_ITEM_LIST, JSON.stringify(this.cartItemList));
  }

  updateCartItemQuantity(productId: number, quantity: number) {

    if (quantity === 0) {   // Remove Item 

      this.removeCartItemFromList( productId );
    }
    else {

      const found = this.cartItemList.find(e => e.prodId === productId);
      if (found) {
        found.Quantity = quantity;

        window.localStorage.setItem(KeyNames.CART_ITEM_LIST, JSON.stringify(this.cartItemList));
      }
    }
  }
}